module.exports = __webpack_public_path__ + "static/gothamhtf-thin-f1e510c00d5cda83e85cc94b2b28ff24.otf";